import classNames from "classnames"
import React from "react"

import ProductOption, { ProductOptionProps } from "./ProductOption"
import Toast from "../../../../Toast"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"

export type VariantsProps = {
  description?: string
  selectedOption: number
  onChange: ProductOptionProps["onClick"]
  options: Omit<ProductOptionProps, "id" | "onClick" | "isActive">[]
  className?: string
}

const Variants = ({
  description,
  selectedOption,
  onChange,
  options,
  className,
}: VariantsProps) => {
  const toast = options[selectedOption].toast

  return (
    <section className={classNames(className, "pt-12 sm:pt-32")}>
      {description && (
        <Typography
          text={description}
          size="body-md"
          color={Color.Black}
          font="grotesk"
          weight="medium"
          className="pb-10 sm:pb-16"
        />
      )}
      <div className="flex flex-col gap-16 sm:gap-20">
        {options.map((option, index) => (
          <ProductOption
            id={index}
            key={`VariantOptions-${index}`}
            label={option.label}
            isActive={selectedOption === index}
            toast={option.toast}
            onClick={onChange}
          />
        ))}
      </div>
      {toast?.text && (
        <Toast
          className="mt-16 sm:mt-24"
          text={toast?.text}
          variant={toast?.variant}
        />
      )}
    </section>
  )
}

export default Variants
